import {Card} from 'platform/components';
import {Box} from 'platform/foundation';
import {match} from 'ts-pattern';

import {useParams} from 'react-router-dom';

import {isArray} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {customerRoutes} from '@dms/routes';
import {DmsDataGrid} from '@dms/shared';
import {noop} from '@dms/teas';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback, QueryFilterObject} from 'features/eag-grid';

export function VehicleCustomersCard() {
  const id = useParams()?.id as string;
  const navigate = useNavigate();

  const queryModifier = (filter: QueryFilterObject) => ({
    ...filter,
    vehicle: [id],
  });

  const actionCallback: ActionCallback = ({actionKey, rowId}) => {
    const customerId = isArray(rowId) ? rowId[0] : rowId;

    match(actionKey)
      .with('detail', () => {
        navigate(composePath(customerRoutes.detail, {params: {id: customerId}}));
      })
      .otherwise(noop);
  };

  return (
    <Card title={i18n.t('page.customers.title')}>
      <Box height={80}>
        <DmsDataGrid
          gridCode="vehicle-customers-list"
          actionCallback={actionCallback}
          queryModifier={queryModifier}
        />
      </Box>
    </Card>
  );
}
